/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { defineMessages } from 'react-intl';
import sortBy from 'lodash/sortBy';

import { fetchGet } from 'FetchAPIs';
import { formatErrorResponse } from 'responseFormatterFunctions';
import { I18NError } from 'Utils';

const DOMAIN_URL = '/api/kpi/domainconfigs';

const messages = defineMessages({
  errorDomains: 'Error loading domains. {message}',
});

export const getDomainsAPI = () =>
  fetchGet(`${DOMAIN_URL}/domains`)
    .then(
      (
        response // map these domains into arrays keyed by their name
      ) =>
        Array.isArray(response)
          ? sortBy(response, ['sequenceOrder', 'value']).reduce((acc, domain) => {
              if (!acc[domain.name]) {
                acc[domain.name] = [domain];
              } else {
                // if we already have this domain
                acc[domain.name].push(domain);
              }
              return acc;
            }, {})
          : null
    )
    .catch(error => {
      throw new I18NError(messages.errorDomains, {
        message: formatErrorResponse(error),
      });
    });
